import React from 'react';
import InputMask from "react-input-mask";

//Styles
import Styles from './BirthInput.module.scss';

//Utils
import PropTypes from 'prop-types';

const BirthInput = React.forwardRef(({validationError = null, placeholder, name, value, disabled, setInputValue}, ref) => {
    const changeHandler = (eventValue) => {
        setInputValue(eventValue)
    };

    return (
        <div className={Styles.container}>
            {validationError !== null ? (
                <label className={Styles.error}>
                    {validationError}
                </label>
            ) : (
                <label className={Styles.focus}>
                    {name}
                </label>
            )}

            <InputMask
                ref={ref}
                className={Styles.input}
                style={{borderBottom: validationError ? '1px solid red' : ''}}
                mask="dD/mM/yYYY"
                formatChars={{
                    'd': '[0-3]',
                    'D': '[0-9]',
                    'm': '[0-1]',
                    'M': '[0-9]',
                    'y': '[1-2]',
                    'Y': '[0-9]',
                }}
                onChange={(e) => changeHandler(e.target.value)}
                disabled={disabled}
                value={value}
                placeholder={placeholder}

            />
        </div>
    );
});

BirthInput.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    type: PropTypes.string,
    disabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
    setInputValue: PropTypes.func
};

export default BirthInput
